import { render } from "./teaser-button.vue?vue&type=template&id=2e81e665"
import script from "./teaser-button.vue?vue&type=script&lang=js"
export * from "./teaser-button.vue?vue&type=script&lang=js"

import "./teaser-button.vue?vue&type=style&index=0&id=2e81e665&lang=scss"

import exportComponent from "/Users/bornasepic/Desktop/projects/grau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__